import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  children: ReactNode;
};

export default function CreateEntityScroll({ children, className }: Props) {
  return (
    <div className={cn("grow w-full relative", className)}>
      <div className="absolute inset-0 overflow-y-auto overflow-x-clip pr-4">{children}</div>
    </div>
  );
}
